import React from 'react';
import IconBase from './IconBase';

const ArrowLeftIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M10.4,6.5c0.2,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5l-3.7,3.7h12.4c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5s-0.3,0.2-0.5,0.2H6.7l3.7,3.7c0.2,0.1,0.2,0.3,0.2,0.5c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2l-5-5c-0.1-0.1-0.1-0.2-0.2-0.2c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.2-0.2l4.9-4.9c0.1-0.1,0.3-0.2,0.5-0.2C10,6.3,10.2,6.4,10.4,6.5z"/>
</IconBase>
    )
}

export default ArrowLeftIcon;